import axios, {AxiosInstance} from 'axios'
import router from '@/router';
import {ErrorToast} from "@/components/VueToast";
import { piniaModalStore } from '@/store/piniaModalStore';


export const BASE_URL =
    process.env.NODE_ENV === 'development'
        ? process.env.VUE_APP_DEV_MODE
        : process.env.VUE_APP_PRO_MODE;

export const TENANT_KEY = process.env.VUE_APP_TENANT_KEY


export const client: AxiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    // timeout: 40000 // Set timeout to 40 seconds (default is 0, which means no timeout)
});

client.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');    
    const appVersion = localStorage.getItem('appVersion');
    config!.headers!['app-version'] = appVersion ?? '';
    config!.headers!['tenant-key'] = TENANT_KEY ?? '';

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

client.interceptors.response.use(
    (response) => {
       
        return response
    },
    (err) => {
        const {status, data} = err.response ?? {};
        const originalConfig = err.config;
        const isLoginScreen = originalConfig?.url.includes('/login');
        
        const appVersion = err.response.headers['app-version'];
        
        if (status === 505) {
            const modalStore = piniaModalStore();
            modalStore.setModalData(true);
            localStorage.setItem('appVersion', appVersion ?? '');
        }    

        if (status === 401) {
            localStorage.clear();
            router.push({name: 'login'});
            // void ErrorToast(data?.message);
        }

        // if ((status === 401 || status === 403) && !isLoginScreen) {
        //     localStorage.clear()
        //     router.push({name: 'login'});
        // }

        return Promise.reject(err);
    }
);

export default client